module.exports = __webpack_public_path__ + "img/9788954428255.ad8e90c2.jpg";